// extracted by mini-css-extract-plugin
export default {"selector":"ecole-selector_selector__ND7nu","ecoles":"ecole-selector_ecoles__ajxtI","expand":"ecole-selector_expand__Sx4hQ","onlyOne":"ecole-selector_onlyOne__lPwPX"};